import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-12 md:py-24 bg-blush relative overflow-hidden" data-id="element-133">
      <div className="max-w-4xl mx-auto px-5 lg:px-8 relative z-10" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-6 md:p-16 rounded-2xl shadow-lg text-center relative" data-id="element-135">
          <svg className="absolute top-4 left-4 md:top-8 md:left-8 w-8 h-8 md:w-12 md:h-12 text-rosegold/20" fill="currentColor" viewBox="0 0 24 24" data-id="element-136">
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-137" />
          </svg>

          <p className="text-lg md:text-2xl font-serif text-charcoal leading-relaxed mb-4 md:mb-8 relative z-10" data-id="element-138">
            En solo 7 días, la mayoría de nuestras lectoras reportan una
            reducción drástica de las fugas de orina al toser o reír.
          </p>
          <p className="text-base md:text-lg text-charcoal/80 leading-relaxed" data-id="element-139">
            Al finalizar los 21 días, notarás cómo tus pantalones cierran con
            más facilidad y cómo esa sensación de "pesadez" en la pelvis
            desaparece por completo.
          </p>
        </motion.div>
      </div>
    </section>;
}